import DateToRender from './DateToRender';

export default DateToRender;
